import * as React from "react";
import Button from "components/common/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

export default function FaqCategoriesStatus({
  open,
  handleEnable,
  handleStatusClose,
  Status,
  CategoriesStatus,
  handleCloseDialoge,
  faqstatus,
  onClickModel
}) {
 
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleCloseDialoge}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {faqstatus === 0 ? (
          <DialogTitle id="alert-dialog-title" sx={{ fontSize: "15px" }}>
            {"Are you sure you want to Disable this item ?"}
          </DialogTitle>
        ) : (
          <DialogTitle id="alert-dialog-title" sx={{ fontSize: "15px" }}>
            {"Are you sure you want to Enable this item ?"}
          </DialogTitle>
        )}
        <DialogActions
          sx={{
            justifyContent: "space-around",
          }}
        >
          {faqstatus === 0 ? (
            <>
              <Button
                onClick={() => onClickModel()}
                sx={{
                  backgroundColor: "red",
                  color: "white",
                  fontSize: "15px",
                }}
              >
                Disable
              </Button>
              <Button
                sx={{ fontSize: "15px" }}
                onClick={handleCloseDialoge}
                autoFocus
              >
                Close
              </Button>
            </>
          ) : (
            <>
              <Button
                onClick={() => onClickModel()}
                sx={{
                  color: "white",
                  fontSize: "15px",
                }}
              >
                Enable
              </Button>
              <Button
                sx={{ fontSize: "15px", backgroundColor:'red' }}
                onClick={handleCloseDialoge}
                autoFocus

              >
                Close
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
